import { TreeViewItem } from '../@types/tree-view-item';
import ServiceUserAccount from '../@types/service-user-account';
import {ResourceType} from '../@types/resource-type';
import Swal from 'sweetalert2';

export function makeServiceUserAccount(user: any): ServiceUserAccount {
    let serviceUserAccount: ServiceUserAccount = {} as ServiceUserAccount;
    serviceUserAccount.id = user.id;
    serviceUserAccount.username = user.username;
    serviceUserAccount.isActive = user.isActive;
    serviceUserAccount.superUser = user.superUser;
    serviceUserAccount.serviceUser = user.serviceUser;
    serviceUserAccount.sourceName = user.sourceName;
    serviceUserAccount.name = user.username;
    serviceUserAccount.apiKey = user.apiKey;
    return serviceUserAccount;
}

export function serviceUserAccountTreeItem(serviceUserAccount: ServiceUserAccount): TreeViewItem {
    return {
        id: serviceUserAccount.id!.toString(),
        object: serviceUserAccount,
        name: serviceUserAccount.username,
        type: ResourceType.SERVICE_USER_ACCOUNTS,
        groupRole: serviceUserAccount.isActive ? 'ACTIVE' : 'EXPIRED'
    };
}

export function serviceUserAccountTreeItems(serviceUserAccounts: ServiceUserAccount[]): TreeViewItem[] {
    return serviceUserAccounts
        .sort((a: ServiceUserAccount, b: ServiceUserAccount) => a.username.localeCompare(b.username))
        .map((serviceUserAccount: ServiceUserAccount) => serviceUserAccountTreeItem(serviceUserAccount));
}

export function addOrUpdateUser(serviceUserAccount: ServiceUserAccount, serviceUserAccounts: ServiceUserAccount[]): ServiceUserAccount[] {
    const newUserList: ServiceUserAccount[] = [...serviceUserAccounts];

    let index = newUserList.findIndex((u: ServiceUserAccount) => u.id == serviceUserAccount.id);
    if (index === -1) {
        newUserList.push(serviceUserAccount);
    } else {
        newUserList[index] = serviceUserAccount;
    }
    return newUserList.sort((a: ServiceUserAccount, b: ServiceUserAccount) => a.username.localeCompare(b.username));
}

export function   displayApiKey(serviceUser: ServiceUserAccount): void {
    if (serviceUser.apiKey) {
        Swal.fire({
            title: `API Key for service user  '${serviceUser.username}'`,
            html: `
                <div style="margin-bottom: 10px;">
                    <strong id="api-key" style="border: 1px solid #CCC; padding: 10px;">${serviceUser.apiKey}</strong>
                </div>
                <button id="copy-api-key" class="swal2-confirm swal2-styled">Copy to Clipboard</button>
                <br/>
                <span>Make a note of it, as it will not be shown again.</span>`,
            icon: 'success',
            didOpen: () => {
                const copyBtn = document.getElementById('copy-api-key');
                const apiKey = serviceUser.apiKey;
                copyBtn?.addEventListener('click', () => {
                    navigator.clipboard.writeText(apiKey ?? '');
                    copyBtn.textContent = 'Copied!';
                    setTimeout(() => copyBtn.textContent = 'Copy', 3000);
                });
            }
        });
    } else {
        Swal.fire({
            title: 'No API Key available',
            text: `No API Key available for service user ${serviceUser.username}.`,
            icon: 'warning'
        });
    }
}


